
import React, { useState ,useEffect } from 'react'
import axios from 'axios'
import { BeatLoader } from 'react-spinners'
import { css } from '@emotion/core'

const Announcements = () => {

    const [ loading, setLoading ] = useState(false)
      
    useEffect(() => {
        setLoading(true)
        axios.get('https://hackmakers.com/wp-json/wp/v2/posts/1141')
        .then((res) => {
            //console.log(res)
            // setData(res.data)
            document.getElementById('announcement-body').innerHTML = res.data.content.rendered
            document.getElementById('announcement-title').innerHTML = res.data.excerpt.rendered
            document.getElementById('announcement-date').innerHTML = res.data.modified;
            setLoading(false)
        })
        .catch((err) => {
            console.log(err)
        })
    }, [])

        const announcementBtn = {
            backgroundColor: 'white',
            border: 'none',
            cursor: 'pointer',
            color: '#CC2E72',
            fontWeight: 'bold',
            padding: 'none',
            margin: 'none',
            fontSize: '15px'
        }

        const announcementSection = {
            backgroundColor: 'white',
            border: '2px solid #CC2E72',
            borderRadius: '10px',
            width: '100%',
            padding: '10px',
            marginTop: '-7%'
        }

        const loaderStyle = css`
        display: flex;
        align-items: center;
        justify-content: center
        `

        return (
            <div>
                <div style={announcementSection}>
                    <h3 id = "announcement-title" style = {{marginLeft: '10px'}}>&nbsp;</h3>
                    {/* <p style={{color: '#3f3d3d'}}>Author* Title </p> */}
                    <p id ="announcement-date" style = {{color: '#3f3d3d', marginLeft: '10px'}}></p>
                    <p id ="announcement-body" style = {{marginLeft: '10px'}}></p>
                    
                    <a style={announcementBtn}
                        href="//digitaldefencehack.slack.com/app_redirect?channel=announcements" target="_blank" rel="noopener noreferrer">
                        See detailed announcements on Slack
                    </a>
                    </div>
                    :
                <BeatLoader 
                    css = { loaderStyle }
                    size = {32}
                    color = "#CC2E72" 
                    loading={loading}
                />
            </div>
        )
    }

export default Announcements
